import { useEffect, useState } from "react";
import { get } from "lodash-es";
import {
	createStyles,
	makeStyles,
	useTheme,
	type Theme,
} from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import type { Craft } from "../../models/Craft";
import { Grid } from "@material-ui/core";
import { ErrorModal } from "@dexteel/mesf-core";
import { getCrafts } from "@/pages/task-list/repositorie/TaskListRepositorie";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-root": {
				backgroundColor: "#FFF",
			},
		},
		formControl: {
			width: "99%",
			marginTop: 8,
		},
	}),
);

const getStyles = (craftId: number, crafts: Craft[], theme: Theme) => {
	return {
		fontWeight: !!crafts.find((p) => p.CraftId === craftId)
			? theme.typography.fontWeightRegular
			: theme.typography.fontWeightMedium,
	};
};

type Props = {
	value: number;
	onChange: Function;
	disabled?: boolean;
};

export const CraftPicker = ({ value, onChange, disabled }: Props) => {
	const classes = useStyles();
	const theme = useTheme();
	const [crafts, setCrafts] = useState<Craft[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	useEffect(() => {
		let canceled = false;
		setIsLoading(true);
		getCrafts()
			.then((res) => {
				if (res.ok) {
					const craftsData = get(res, "data.tables[0].rows", null);
					if (craftsData) {
						if (canceled) return;
						setCrafts(craftsData);
					} else console.log("algo falló");
					setIsLoading(false);
				} else {
					setError(res.message);
					setIsLoading(false);
				}
			})
			.finally(() => {
				if (canceled) return;
			});
		return () => {
			canceled = true;
		};
	}, []);

	return (
		<div className={classes.root}>
			{crafts.length ? (
				<FormControl
					variant="outlined"
					margin="dense"
					className={classes.formControl}
				>
					<InputLabel id="crafts-picker-label">Crafts</InputLabel>
					<Select
						disabled={disabled ? disabled : false}
						style={{ padding: "0 !important" }}
						labelId="crafts-picker-label"
						id="crafts-picker"
						autoWidth={true}
						value={value}
						onChange={onChange as any}
						label="Crafts"
					>
						{crafts.map((craft) => (
							<MenuItem
								key={`craft-${craft.CraftId}`}
								value={craft.CraftId}
								style={getStyles(craft.CraftId, crafts, theme)}
							>
								<Grid container alignItems="center">
									<div
										style={{
											height: 18,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<div
											style={{
												height: 20,
												width: 20,
												borderRadius: 4,
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												background: craft.Color || "#FFFFFF",
											}}
										>
											<div
												style={{
													color: "#FFF",
													fontWeight: 600,
													margin: "auto 0",
													lineHeight: 0,
												}}
											>
												<div>{craft.CraftName.charAt(0) || ""}</div>
											</div>
										</div>
									</div>
									<div style={{ marginLeft: 10 }}>{craft.CraftName}</div>
								</Grid>
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
			<ErrorModal error={error} onHide={() => setError("")} />
		</div>
	);
};
